






















































































































import { Component, Vue } from "vue-property-decorator";
import { detectImageCapture, detectWebShare } from "./feature-detection";

@Component({
  components: {
    Snackbars: () => import("./components/Snackbars.vue"),
    ImageList: () => import("./components/ImageList.vue"),
  },
})
export default class App extends Vue {
  drawer = null;
  imageCaptureSupported = true;
  webShareSupported = false;
  speedDial = false;

  created() {
    this.imageCaptureSupported = detectImageCapture();
    this.webShareSupported = detectWebShare();
    const now = new Date();
    this.name =
      `${now.getMonth() + 1}-${now.getDate()}-${now.getFullYear()} ` +
      `${now.getHours()}:` +
      `${now.getMinutes() < 10 ? "0" : ""}${now.getMinutes()}`;

    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.$store.commit("storePwaEvent", e as any);

      if (
        !localStorage.getItem("doclight:pwaPromptDontShow") &&
        this.imageCaptureSupported // don't prompt for "the best experience" if the main functionality is gutted
      ) {
        this.$store.commit("snackbars/show", "pwaPrompt");
      }
    });

    const darkThemeQuery = matchMedia("(prefers-color-scheme: dark)");
    this.$vuetify.theme.dark = darkThemeQuery.matches;
    darkThemeQuery.addEventListener(
      "change",
      (e) => (this.$vuetify.theme.dark = e.matches)
    );
  }

  get name(): string {
    return this.$store.state.documentName;
  }

  set name(newName: string) {
    this.$store.commit("setName", newName);
  }

  addImage(capture = true) {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/jpeg";
    if (capture && "capture" in input) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (input as any).capture = true;
    }
    input.style.display = "none";
    input.addEventListener("input", () => {
      if (input?.files?.[0]) {
        this.$store.commit("addImage", input.files[0]);
      }
    });
    document.body.appendChild(input);
    input.click();
    input.remove();
  }

  async downloadPdf() {
    const pdf = await import("./pdf");
    if (
      await pdf.downloadPdf(
        this.$store.state.images,
        this.$store.state.documentName
      )
    ) {
      this.$store.commit("snackbars/show", "downloadSuccess");
    } else {
      this.$store.commit("snackbars/show", "downloadError");
    }
  }

  share() {
    navigator.share({
      title: "Doclight",
      text: "Try Doclight, the simple PDF-scanning app that runs in the browser",
      url: "https://quantaly.github.io/doclight",
    });
  }
}
